<template>
  <div class="cart-item py-4 border-b border-solid border-gray-550">
    <div class="flex flex-row space-x-0 lg:space-x-8 gap-2">
      <div class="flex-initial w-1/3 lg:min-w-max">
        <img :src="img" class="product__image" />
      </div>
      <div class="flex-1 w-auto flex flex-col">
        <template>
          <div class="cart-item__description">{{ data.product_name }}</div>
          <div class="text-xs text-gray-150 mt-2 break-all" v-if="data.sku_item_parent_name_1">
            <span class="font-bold">{{ data.sku_item_parent_name_1 }}</span
            >:
            <span class="ml-2">{{ data.sku_set_item_name1 }}</span>
          </div>
          <div class="text-xs text-gray-150 mt-2 break-all" v-if="data.sku_item_parent_name_2">
            <span class="font-bold">{{ data.sku_item_parent_name_2 }}</span
            >:
            <span class="ml-2">{{ data.sku_set_item_name2 }}</span>
          </div>
          <div class="cart-item__wrap mt-4 mb-2">
            <div class="text-sm flex">
              <i18n path="common.cart.formatLabel" class="flex items-center">
                <template #label>
                  <span>{{ $t('common.cart.unitPrice') }}</span>
                </template>
                <template #tax>
                  <span class="tax-font">{{ $t('common.cart.withTax') }}</span>
                </template>
              </i18n>
              <span>{{ $t('cartList.item.separatorColon') }}</span>
              <i18n path="common.cart.formatPrice">
                <template #price>
                  <span>{{ data.price.toLocaleString() }}</span>
                </template>
                <template #unit>
                  <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
                </template>
              </i18n>
            </div>
          </div>
          <div class="text-sm">
            <span>{{ $t('cartList.item.quantity') }}</span>
            <span>{{ $t('cartList.item.separatorColon') }}</span>
            <span>{{ data.quantity }}</span>
          </div>
          <div class="text-base mt-4 font-bold flex">
            <i18n path="common.cart.formatLabel" class="flex items-center">
              <template #label>
                <span>{{ $t('common.cart.subTotal') }}</span>
              </template>
              <template #tax>
                <span class="tax-font">{{ $t('common.cart.withTax') }}</span>
              </template>
            </i18n>
            <span>{{ $t('cartList.item.separatorColon') }}</span>
            <i18n path="common.cart.formatPrice">
              <template #price>
                <span>{{ data.subtotal.toLocaleString() }}</span>
              </template>
              <template #unit>
                <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
              </template>
            </i18n>
          </div>
          <div v-if="data.discount_amount_total !== 0" class="text-xs mt-1">
            <i18n path="common.cart.formatLabel">
              <template #label>
                <span class="font-light">{{ $t('common.label.priceDiscount') }}</span>
              </template>
            </i18n>
            <span class="font-light">{{ $t('cartList.item.separatorColon') }}</span>
            <i18n path="common.cart.formatPrice" class="text-red">
              <template #price>
                <span>{{ data.discount_amount_total.toLocaleString() }}</span>
              </template>
              <template #unit>
                <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
              </template>
            </i18n>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object, required: true, default: () => {} },
  },
  computed: {
    img() {
      return this.data.product_image ? this.data.product_image : require('@/assets/images/gray-image.svg')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/cart-list-item.scss';
</style>
